import {createAction} from 'redux-actions'
import {COMMENTS_SCROLL_TO, LOAD_COMMENTS_LIMIT} from './constants'
import {createActionObject} from '../../redux/utils'
import {setCommentsOrderInLocalStorage} from './utils'

const HIGHLIGHT_NEW_COMMENTS_DELAY = 500

export default function({
    actionTypes: {
        NEW_COMMENTS_ADD,
        OLD_COMMENTS_ADD,
        COMMENTS_INFO_CLEAR,
        COMMENT_REMOVE,
        CHANGE_COMMENTS_ORDER,
        COMMENTS_LOADED_SET,
        COMMENTS_LOADING_SET,
        SENDING_COMMENT_SET,
        RECENTLY_ADDED_COMMENTS_ADD,
        RECENTLY_ADDED_COMMENTS_REMOVE,
        COMMENTS_SCROLL_TO_SET,
        EDITING_COMMENT_ID_SET,
        EDITING_COMMENT_TEXT_SET,
        UPDATE_COMMENT,
        UPDATING_COMMENT_ID_SET,
        SHOW_NEW_COMMENT_INPUT_SET,
        NEW_COMMENT_SET,
        NEW_COMMENT_REMOVE,
    }
}) {
    const addNewComments = createAction(NEW_COMMENTS_ADD)
    const addOldComments = createAction(OLD_COMMENTS_ADD)
    const clearCommentsInfo = createAction(COMMENTS_INFO_CLEAR)
    const removeComment = createAction(COMMENT_REMOVE)
    const setCommentsLoaded = createAction(COMMENTS_LOADED_SET)
    const setCommentsLoading = createAction(COMMENTS_LOADING_SET)
    const setSendingComment = createAction(SENDING_COMMENT_SET)
    const addRecentlyAddedComments = createAction(RECENTLY_ADDED_COMMENTS_ADD)
    const removeRecentlyAddedComments = createAction(RECENTLY_ADDED_COMMENTS_REMOVE)
    const setCommentsScrollTo = createAction(COMMENTS_SCROLL_TO_SET)
    const setEditingCommentId = createAction(EDITING_COMMENT_ID_SET)
    const setEditingCommentText = createAction(EDITING_COMMENT_TEXT_SET)
    const updateComment = createAction(UPDATE_COMMENT)
    const setUpdatingCommentId = createAction(UPDATING_COMMENT_ID_SET)
    const setShowNewCommentInput = createAction(SHOW_NEW_COMMENT_INPUT_SET)
    const setNewComment = createAction(NEW_COMMENT_SET)
    const removeNewComment = createAction(NEW_COMMENT_REMOVE)

    const saveCommentSuccess = commentsInfo => dispatch => {
        dispatch(setSendingComment(false))
        dispatch(setShowNewCommentInput(false))
        dispatch(addNewComments(commentsInfo))
        dispatch(setCommentsScrollTo(COMMENTS_SCROLL_TO.RECENTLY_ADDED))
        dispatch(addRecentlyAddedComments(commentsInfo.comments))
        setTimeout(() => dispatch(removeRecentlyAddedComments(commentsInfo.comments)), HIGHLIGHT_NEW_COMMENTS_DELAY)
    }

    const deleteCommentSuccess = (deletedCommentId, commentsInfo) => dispatch => {
        dispatch(removeComment(deletedCommentId))
        dispatch(addNewComments(commentsInfo))
        dispatch(addRecentlyAddedComments(commentsInfo.comments))
        setTimeout(() => dispatch(removeRecentlyAddedComments(commentsInfo.comments)), HIGHLIGHT_NEW_COMMENTS_DELAY)
    }

    const loadMoreCommentsSuccess = (commentsInfo, offset, isNewCommentsOnTop) => dispatch => {
        dispatch(setCommentsLoading(false))
        dispatch(addOldComments(commentsInfo))
        dispatch(setCommentsLoaded(commentsInfo.comments.length < LOAD_COMMENTS_LIMIT))
        if (offset > 0 && isNewCommentsOnTop) {
            dispatch(setCommentsScrollTo(COMMENTS_SCROLL_TO.LOADED_OLDER))
        }
    }

    const updateCommentSuccess = data => dispatch => {
        dispatch(setUpdatingCommentId(null))
        dispatch(setEditingCommentId(null))
        dispatch(setEditingCommentText(''))
        dispatch(addNewComments(data.commentsInfo))
        dispatch(addRecentlyAddedComments(data.commentsInfo.comments))
        setTimeout(() => dispatch(removeRecentlyAddedComments(data.commentsInfo.comments)), HIGHLIGHT_NEW_COMMENTS_DELAY)
        dispatch(updateComment(data.updatedComment))
    }

    const cancelEditComment = () => dispatch => {
        dispatch(setEditingCommentText(''))
        dispatch(setEditingCommentId(null))
    }

    const updateEditingCommentText = (text) => dispatch => {
        dispatch(setEditingCommentText(text))
    }

    const resetCommentsScrollTo = () => (dispatch) => {
        dispatch(setCommentsScrollTo(null))
    }

    const changeCommentsOrder = isNewCommentsOnTop => dispatch => {
        dispatch(createActionObject(CHANGE_COMMENTS_ORDER, isNewCommentsOnTop))
        setCommentsOrderInLocalStorage(isNewCommentsOnTop)
    }

    return {
        saveCommentSuccess,
        loadMoreCommentsSuccess,
        deleteCommentSuccess,
        clearCommentsInfo,
        changeCommentsOrder,
        setCommentsLoading,
        setSendingComment,
        setCommentsLoaded,
        resetCommentsScrollTo,
        updateEditingCommentText,
        cancelEditComment,
        updateCommentSuccess,
        setUpdatingCommentId,
        setEditingCommentId,
        removeComment,
        setShowNewCommentInput,
        setNewComment,
        removeNewComment,
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/comments/actionsGenerator.js